import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { API } from '../../../request/api';
import PopupNoticeWrapper from '../PopupNoticeWrapper/PopupNoticeWrapper';

const PopupNotices = ({ showPopupNoticesModal, setShowPopupNoticesModal, showPopupCondition }) => {
  const Login = useSelector((state) => state.Login);
  const activeCategory = JSON.parse(localStorage.getItem('carfillo'))?.Activity?.activeCategory;
  const [popUpNoticesInfo, setPopupNoticesInfo] = useState({ image: '', text: '', url: '/' });
  const currentTime = new Date();
  const currentTimestamp = currentTime.getTime();
  const homepagePopupShowTime = localStorage.getItem('scf-homepage-popup-show-time');

  const [showTime, setShowTime] = useState(
    homepagePopupShowTime ? Number(homepagePopupShowTime) : null
  );

  const location = useLocation();
  const pathParts = location.pathname.split('/').filter(Boolean);
  const params = [
    pathParts[1],
    pathParts[2],
    pathParts[3],
    pathParts[4],
    pathParts[5],
    pathParts[6]
  ].filter((catItem) => catItem !== undefined);

  useEffect(() => {
    if (params.length < 2 && activeCategory === undefined) {
      API.get
        .popup(Login.city_id, '')
        .then((response) => {
          if (response.success) {
            setPopupNoticesInfo({
              ...popUpNoticesInfo,
              text: response.data.text,
              image: response.data.image,
              url: response.data.url
            });
          }
          return response;
        })
        .catch((error) => {
          console.error('Popup Error:', error.message);
        });
    } else if (activeCategory != null) {
      API.get
        .popup(Login.city_id, activeCategory)
        .then((response) => {
          if (response.success) {
            setPopupNoticesInfo({
              ...popUpNoticesInfo,
              text: response.data.text,
              image: response.data.image,
              url: response.data.url
            });
          }
          return response;
        })
        .catch((error) => {
          console.error('Popup Error:', error.message);
        });
    }
    // eslint-disable-next-line
  }, [Login.city_id, activeCategory]);

  useEffect(() => {
    if (!showTime && showPopupCondition && (popUpNoticesInfo.image || popUpNoticesInfo.text)) {
      setShowPopupNoticesModal(true);
    } else if (
      currentTimestamp >= showTime &&
      showPopupCondition &&
      (popUpNoticesInfo.image || popUpNoticesInfo.text)
    ) {
      setShowPopupNoticesModal(true);
    }

    // eslint-disable-next-line
  }, [popUpNoticesInfo.image, popUpNoticesInfo.text, showPopupCondition, showTime]);

  return (
    <PopupNoticeWrapper
      onCancel={() => {
        setShowPopupNoticesModal(false);
        localStorage.setItem('scf-homepage-popup-show-time', currentTimestamp + 10 * 60 * 1000);
        setShowTime(currentTimestamp + 10 * 60 * 1000);
      }}
      onClickButton={() => {
        setShowPopupNoticesModal(false);
        localStorage.setItem('scf-homepage-popup-show-time', currentTimestamp + 10 * 60 * 1000);
        setShowTime(currentTimestamp + 10 * 60 * 1000);
      }}
      PopupNoticeWrapperInfo={popUpNoticesInfo}
      showModal={showPopupNoticesModal}
    />
  );
};

export default PopupNotices;
